<template>
  <div class="cta-container">
    <div class="cta-heading">{{ title }}</div>

    <OrangeArrowButton
      class="cta-button"
      :title="MAIN_CTA_PARAMS.title"
      :href="MAIN_CTA_PARAMS.href"
    />
  </div>
</template>
<script>
import OrangeArrowButton from '../../components/main/OrangeArrowButton.vue';
import { SIGN_UP_COMPANY_ROUTE_HREF } from '../../router';

export default {
  name: 'SignUpCtaSection',
  components: {
    OrangeArrowButton,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      SIGN_UP_COMPANY_ROUTE_HREF,
      MAIN_CTA_PARAMS: {
        title: 'Sign Up Your Company',
        href: SIGN_UP_COMPANY_ROUTE_HREF,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.cta-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  @media screen and (max-width: 768px) {
    padding: 0 20px;
  }
}

.cta-heading {
  font-size: 2.5rem;
  font-weight: bold;
  color: #333;

  @media screen and (max-width: 768px) {
    font-size: 2rem;
  }
}

.cta-button {
  margin-top: 1rem;
}
</style>
